module.exports = __webpack_public_path__ + "img/image (10).e82be092.jpg";